import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { catchError, Observable, of, Subject, takeUntil, throwError } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import Messages from '@core/utils/functions/messages.function';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { Dialog } from '@core/models/dialog.interface';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  
  private cancelRequests = new Subject<void>();

  private headerValue:string | null = 'true'; 
  requests: any[] = [];

  constructor(private baseService: BaseService, private router: Router, private _messages: Messages, private modalService: ModalService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.cancelAllRequests(); // Cancela todas las peticiones en cada cambio de ruta
      }
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    
    // El checkout usa su propio token (sessionStorage) para no pisar ni usar la sesion
    // del admin: los dos viven en el mismo origen y la API los autoriza distinto.
    const isCheckout = window.location.hash.startsWith('#/check-out') || window.location.hash.startsWith('#/pre-check-out');
    const AccessToken: string = (isCheckout ? sessionStorage.getItem('CheckoutAccessToken') : localStorage.getItem('AccessToken')) || '';

    let headers = req.headers;
    
    //console.log(headers.has('skip'));
    // Solo se añade el Authorization si no existe la cabecera 'skip'
    if (!req.headers.has('skip') && AccessToken) {
        headers = headers.set('Authorization', 'Bearer ' + AccessToken + '') /*.set('Content-Type', 'application/json').set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*') */
    }else {
      headers = new HttpHeaders()
    }

    const clonedRequest = req.clone({ headers });
    // console.log('clonedRequest: ', clonedRequest);
    

    return next.handle(clonedRequest)
      .pipe(
        takeUntil(this.cancelRequests), // Aquí se cancela la petición si es necesario
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            return this.handleError(clonedRequest, next, error);
          } else {
            return throwError(() => error);
          }
        }));
  }

  handleError(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse): Observable<any> {
    // console.log('request: ', request);
    if (request.headers.has('type-require-alert')) {
      // Aquí puedes hacer algo condicionalmente
      this.headerValue = request.headers.get('type-require-alert');
      //console.log(`type-require-alert value: ${this.headerValue}`);
    }
    let message:string = '';
    switch (error.status) {
      case HttpStatusCode.BadRequest: // 400
        if (error.error?.message) {
          message = error.error?.message;
        }
          this.showErrorMessage(!!message ? message : 'A problem occurred with the request.', () =>{});
        break;
      case HttpStatusCode.Unauthorized: //401
        this.showErrorMessage('Your session has expired.', () => this.router.navigate(['login']));
        break;
      case HttpStatusCode.Forbidden: //403
        this.showErrorMessage('You do not have permissions to perform this action.', () =>{});
        break;
      case HttpStatusCode.NotFound: //404
        if (error.error?.message) {
          message = error.error?.message;
        }
        //this.showErrorMessage(!!message ? message : 'A problem occurred with the request.');
        of(new HttpResponse({ status: 404, body: { datos: [[]], error: true, message: message, statusCode: error.error.statusCode } }));
        this.router.navigate(['not-found'])
        break;
      case HttpStatusCode.InternalServerError: //500
        this.showErrorMessage('Internal Server Error.', () =>{});
        break;
      default:
        if (error.error?.message) {
          message = error.error?.message;
        }
        this.showErrorMessage(!!message ? message : 'A problem occurred with the request.', () =>{});
        return throwError(() => error);
      
    }
    return throwError(() => error);
  }

  private showErrorMessage(message: string, callback: () =>  void ): void  {
    this.modalService.closeAllModals();
    setTimeout(() => {
      if (document.querySelectorAll('nz-modal-container').length === 0) {
        if(this.headerValue == 'true') {
          let data: Dialog = {
            icon: {
              name: faCircleExclamation,
              container: 'bg-warning color-warning',
            },
            title: message,
            confirmButton: { text: 'Ok', icon: faCircleCheck },
            padding: '3rem 1.5rem 1.5rem',
            data: {},
            callback: callback || (() => {}),
          };
          
          this._messages.showMessage(data).subscribe({
            next: (response) => {
              callback();
            },
          });
        }
      }
    }, 500);
  }


  // Método para cancelar las peticiones
  cancelAllRequests() {
    this.cancelRequests.next();
  }


}
